/*****************************************************************
 *  Tooth Actions Types
 * ***************************************************************/

export const SET_SELECTED_TOOTH = "SET_SELECTED_TOOTH";
export const CLEAR_SELECTED_TOOTH = "CLEAR_SELECTED_TOOTH";
export const SET_TOOTH_MOVEMENTS = "SET_TOOTH_MOVEMENTS";
export const SET_SELECTED_POINT_ROTATION = "SET_SELECTED_POINT_ROTATION";
export const SET_SELECTED_POINT_TIP = "SET_SELECTED_POINT_TIP";
export const SET_SELECTED_POINT_TORQUE = "SET_SELECTED_POINT_TORQUE";


